import pdfFile from '../../assets/pdf/kiosk.pdf';

function KioskApp() {
  return (
    <div style={{ height: '100vh' }}>
      <iframe
        src={pdfFile}
        style={{ width: '100%', height: '100%', border: 'none' }}
      ></iframe>
    </div>
  );
}

export default KioskApp;
